import { render, staticRenderFns } from "./ForbiddenContent.vue?vue&type=template&id=0c305d0d&"
import script from "./ForbiddenContent.vue?vue&type=script&lang=js&"
export * from "./ForbiddenContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports